/**
 * Module to wrapp Hashing features, currently using a 3rd party library
 * If we decide to change the library or doing it in house, we can do it here
 *
 */

import HashLib from 'hash.js';

import * as DataDogLogs from '~/lib/datadog/datadog';

/**
 * Syncronously function to hash text using sha256
 *
 * @param {string} textToHash
 * @returns
 */
const hashText = (textToHash) => {
  try {
    return HashLib.sha256().update(textToHash).digest('hex');
  } catch (error) {
    DataDogLogs.error('[Allbirds utils] - hashText - Error hashing text', {}, error);
  }
};

/**
 * Function to hash text. This function was provided by Bliss Point.
 * Check document here https://app.asana.com/1/209680782572886/project/1203559010736126/task/1211513253595071. Page 12
 *
 * @param {string} ascii
 * @returns the hashed text
 */
const sha256BlissPoint = (ascii) => {
  function rightRotate(value, amount) {
    return (value >>> amount) | (value << (32 - amount));
  }
  var mathPow = Math.pow;
  var maxWord = mathPow(2, 32);
  var lengthProperty = 'length';
  var i, j;
  var result = '';
  var words = [];
  var asciiBitLength = ascii[lengthProperty] * 8;
  var hash = (sha256BlissPoint.h = sha256BlissPoint.h || []);
  var k = (sha256BlissPoint.k = sha256BlissPoint.k || []);
  var primeCounter = k[lengthProperty];
  var isComposite = {};
  for (var candidate = 2; primeCounter < 64; candidate++) {
    if (!isComposite[candidate]) {
      for (i = 0; i < 313; i += candidate) {
        isComposite[i] = candidate;
      }
      hash[primeCounter] = (mathPow(candidate, 0.5) * maxWord) | 0;
      k[primeCounter++] = (mathPow(candidate, 1 / 3) * maxWord) | 0;
    }
  }
  ascii += '\x80';
  while ((ascii[lengthProperty] % 64) - 56) ascii += '\x00';
  for (i = 0; i < ascii[lengthProperty]; i++) {
    j = ascii.charCodeAt(i);
    if (j >> 8) return;
    words[i >> 2] |= j << (((3 - i) % 4) * 8);
  }
  words[words[lengthProperty]] = (asciiBitLength / maxWord) | 0;
  words[words[lengthProperty]] = asciiBitLength;

  for (j = 0; j < words[lengthProperty]; ) {
    var w = words.slice(j, (j += 16));
    var oldHash = hash;
    hash = hash.slice(0, 8);
    for (i = 0; i < 64; i++) {
      var w2 = w[i - 2],
        w15 = w[i - 15];
      var a = hash[0],
        e = hash[4];
      var temp1 =
        hash[7] +
        (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) +
        ((e & hash[5]) ^ (~e & hash[6])) +
        k[i] +
        (w[i] =
          i < 16
            ? w[i]
            : (w[i - 16] +
                (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15 >>> 3)) +
                w[i - 7] +
                (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2 >>> 10))) |
              0);
      var temp2 =
        (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) +
        ((a & hash[1]) ^ (a & hash[2]) ^ (hash[1] & hash[2]));
      hash = [(temp1 + temp2) | 0].concat(hash);
      hash[4] = (hash[4] + temp1) | 0;
    }
    for (i = 0; i < 8; i++) {
      hash[i] = (hash[i] + oldHash[i]) | 0;
    }
  }

  for (i = 0; i < 8; i++) {
    for (j = 3; j + 1; j--) {
      var b = (hash[i] >> (j * 8)) & 255;
      result += (b < 16 ? 0 : '') + b.toString(16);
    }
  }
  return result;
};

/**
 * Syncronously function to hash and validate email using sha256. This function was provided by Bliss Point.
 * Check document here https://app.asana.com/1/209680782572886/project/1203559010736126/task/1211513253595071. Page 12
 *
 * @param {string} email
 * @returns the hashed email or undefined if the email is invalid
 */
const hashEmailBlissPoint = (email) => {
  function emailIsValid(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
  if (emailIsValid(email)) {
    var hash = sha256BlissPoint(email);
    return hash;
  } else {
    return undefined;
  }
};

export { hashEmailBlissPoint, hashText };
